function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#08b794"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#069edd"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2179",
  "data-name": "Group 2179",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_37427",
  "data-name": "Path 37427",
  d: "M111.5,0A20.451,20.451,0,0,0,91,20.816c0,11.909,18.288,34.58,19.071,35.526a1.874,1.874,0,0,0,1.429.681,1.855,1.855,0,0,0,1.429-.681C113.711,55.4,132,32.726,132,20.816A20.68,20.68,0,0,0,111.5,0Zm0,34.063a13.248,13.248,0,1,1,13.045-13.247A13.162,13.162,0,0,1,111.5,34.063Z",
  transform: "translate(-91 0)",
  fill: "url(#linear-gradient)"
}));

function SvgMarker(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "place",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41,
    height: 57.024,
    viewBox: "0 0 41 57.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.9af0ed72.svg";
export { ForwardRef as ReactComponent };